<template>
  <div class="dgs chat grid-gua paper-grain" data-product="heart">
    <div class="sheet">
      <div class="top">
        <div class="masthead">
          <div class="kicker">AI · 财 · 印 · 识人</div>
          <h1>分析记录</h1>
          <div class="sub">已付费的分析 · 点击继续追问</div>
          <div class="rule"></div>
        </div>
      </div>

      <div class="list mt-4">
        <div
          v-for="(item, index) in recordList"
          :key="index"
          class="card rec"
          @click="gotoDetail(item, index)"
        >
          <div class="thumb">{{ getThumbChar(item) }}</div>
          <div class="info">
            <div class="t">{{ getName(item) }}</div>
            <div class="d" v-if="getTime(item)">{{ getTime(item) }}</div>
            <div class="chips" v-if="item.count">
              <span class="chip">已追问 {{ item.count }}/5</span>
            </div>
          </div>
          <div class="go">→</div>
        </div>
      </div>

      <div v-if="recordList.length === 0 && !loading" class="empty-state">
        暂无分析记录
      </div>
      <div v-if="loading" class="empty-state">
        加载中...
      </div>

      <van-button class="btn btn-seal btn-block mt-4" @click="gotoSubmit">＋ 新增分析</van-button>
      <van-button class="btn btn-ink btn-block mt-2" @click="getList">刷新</van-button>

      <div class="foot">分析记录 · 原生家庭识人术</div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { postAction } from '@/api/manage'
export default {
  name: 'ChatList',
  data() {
    return {
      recordList: [],
      loading: false,
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      this.getList()
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatList')
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    } else {
      this.getList()
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
          this.getList()
        }
      })
    },
    getName(item) {
      // 兼容字符串数组和对象数组
      if (typeof item === 'string') {
        return item
      }
      return item.name || item.session_id || '未命名'
    },
    getThumbChar(item) {
      const name = this.getName(item)
      return name ? name.charAt(0) : '?'
    },
    getTime(item) {
      if (typeof item === 'object' && item.time) {
        return item.time
      }
      return ''
    },
    getList() {
      this.loading = true
      const url = '/chat/history'
      postAction(url, { unionid: this.unionid }).then(res => {
        if (res.data.code == 200) {
          this.recordList = res.data.msg || []
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    gotoDetail(item, index) {
      const name = this.getName(item)
      const sessionId = (typeof item === 'object' && item.session_id) ? item.session_id : ''
      this.$router.push({ path: '/chatDetail', query: { name: name, session_id: sessionId, index: index } })
    },
    gotoSubmit() {
      this.$router.push({ path: '/chatSubmit' })
    }
  }
}
</script>
<style scoped>
@import "../style/design-system.css";

.top { padding-top: 30px; }

/* 记录条目 */
.rec { display: flex; align-items: center; gap: 14px; cursor: pointer; }
.rec .info { flex: 1; min-width: 0; }
.rec .t { font-size: 15.5px; font-weight: 600; letter-spacing: .03em; color: var(--ink); }
.rec .d { font-size: 12px; color: var(--ink-mute); margin-top: 3px; font-variant-numeric: tabular-nums; }
.rec .chips { display: flex; gap: 6px; margin-top: 8px; }
.rec .go { color: var(--seal); font-size: 20px; flex: none; }
.rec .thumb {
  width: 52px; height: 52px; flex: none;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--paper-lo), var(--paper-deep));
  display: grid; place-items: center;
  font-family: var(--f-serif); font-size: 20px; color: var(--ink-soft);
  box-shadow: var(--shadow-card);
}

.empty-state { text-align: center; color: var(--ink-mute); font-size: 14px; margin-top: 40px; padding: 40px 0; }

/* 列表 */
.list { display: flex; flex-direction: column; gap: 10px; }

::v-deep .van-button { font-family: var(--f-sans); }
</style>
